import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    badge: 'items-center gap-1 body-5 i-flex'
  },
  iconSize: 'sm'
} satisfies RecursivePartial<ProductConfig['badge']>
